/**
 * Team management request/response shapes (Phase 3, M3.9).
 *
 * Members are listed with their API-side role projection (owner|admin|member).
 * Invites carry the DB-side role (owner|admin|operator|viewer) since they are
 * stored and returned before the role-mapping layer applies.
 */
import { z } from "zod";
import { IsoTimestampSchema } from "./common.js";
import { TenantRoleSchema } from "./tenants.js";
export const TeamMemberSchema = z.object({
    user_id: z.string().uuid(),
    email: z.string().email(),
    name: z.string().nullable(),
    role: TenantRoleSchema, // API-side: owner|admin|member
    joined_at: IsoTimestampSchema,
});
export const TeamMembersResponseSchema = z.object({
    items: z.array(TeamMemberSchema),
});
export const TeamInviteSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    role: z.enum(["owner", "admin", "operator", "viewer"]),
    expires_at: IsoTimestampSchema,
    created_at: IsoTimestampSchema,
    invite_url: z.string(),
});
export const TeamInvitesResponseSchema = z.object({
    items: z.array(TeamInviteSchema),
});
export const CreateInviteRequestSchema = z.object({
    email: z.string().email(),
    role: z.enum(["admin", "operator", "viewer"]), // cannot invite as owner
});
export const CreateInviteResponseSchema = TeamInviteSchema;
//# sourceMappingURL=team.js.map